var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{class:_vm.props.class,domProps:{"innerHTML":_vm._s(_vm.props.content)}})}
var staticRenderFns = []

export { render, staticRenderFns }